import React from 'react'
import { EmailIcon } from '@diversioteam/diversio-ds'

import { useGetActiveCompanyInformation } from 'hooks/useGetActiveCompany'

import { TemplateAccordion } from './TemplateAccordion'
import { ANONIMITY_DISCLAIMER, EMAIL_TEMPLATES, replacePlaceholders } from './emailTemplates.helpers'
import { EmailTemplatesProps } from './emailTemplates.types'
import * as S from './emailTemplates.styles'

export const EmailTemplates = ({ surveyTitle, surveyDescription, surveyUrl, applyAnonymity }: EmailTemplatesProps) => {
    const { companyInformation } = useGetActiveCompanyInformation()

    const organizationName = companyInformation.name

    const placeholders = {
        surveyTitle,
        surveyUrl,
        organizationName,
        surveyDescription: applyAnonymity
            ? `${surveyDescription}\n\r\n<b>${ANONIMITY_DISCLAIMER}</b>`
            : surveyDescription,
    }

    const transformedEmailTemplates = EMAIL_TEMPLATES.map((template) => ({
        ...template,
        title: replacePlaceholders(template.title, placeholders),
        content: replacePlaceholders(template.content, placeholders),
    }))

    return (
        <S.EmailTemplatesWrapper>
            <S.Header>
                <S.Title>
                    <EmailIcon type="line" />
                    Email Templates
                </S.Title>

                <S.Description>Easily promote your survey using personalized email templates</S.Description>
            </S.Header>

            <S.TemplatesList>
                {transformedEmailTemplates.map(({ id, name, title, content }) => (
                    <S.TemplatesListItem key={id}>
                        <TemplateAccordion id={id} name={name} title={title} content={content} />
                    </S.TemplatesListItem>
                ))}
            </S.TemplatesList>
        </S.EmailTemplatesWrapper>
    )
}
